export default "__VITE_ASSET__DX39u30k__"